import homePoint from '../../assets/img/views/stopDot/home_point.png';
import stopPointArrived from '../../assets/img/views/stopDot/stop_point_arrived.png';
import stopPointCurrent from '../../assets/img/views/stopDot/stop_point_current.png';
import stopPointUnArrived from '../../assets/img/views/stopDot/stop_point_unArrived.png';
import lastPointArrived from '../../assets/img/views/stopDot/last_point_arrived.png';
import lastPointUnArrived from '../../assets/img/views/stopDot/last_point_unArrived.png';

export {
  homePoint,
  stopPointArrived,
  stopPointCurrent,
  stopPointUnArrived,
  lastPointArrived,
  lastPointUnArrived,
};
